import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

/**
 * CardWW3 (Fride) API
 * Оплата международными банковскими картами VISA/MC в долларах через провайдера Fride.
 * Структура эндпоинтов идентична cardww1/cardww2, отличается только путь /api/cardww3/
 * и поле `cardww3` в пакетах /api/topup/.
 */

/**
 * Получить конфигурацию cardww3 (курсы и лимиты)
 */
export const fetchCardWw3Config = async () => {
  try {
    const response = await apiService.makeRequest('/api/cardww3/')

    if (response.cardww3) {
      return { ...response.cardww3, promo: response.promo || null }
    }

    throw new Error('Invalid response format: cardww3 config not found')
  } catch (error) {
    console.error('Error fetching CardWW3 config:', error)
    throw error
  }
}

/**
 * Получить пакеты для cardww3 из общего списка тарифов /api/topup/
 * Фильтрует только те пакеты, у которых есть поле cardww3
 */
export const fetchCardWw3Packages = async () => {
  try {
    const response = await apiService.makeRequest('/api/topup/')

    if (response.topup && Array.isArray(response.topup)) {
      return response.topup.filter((pkg) => pkg.cardww3 !== undefined)
    }

    throw new Error('Invalid response format: topup array not found')
  } catch (error) {
    console.error('Error fetching CardWW3 packages:', error)
    throw error
  }
}

// Нормализация ошибок бэкенда cardww3 к единому виду
const normalizeCardWw3CreateError = (response) => {
  if (!response?.error) return null

  if (response.error === 'error sum') return 'INVALID_AMOUNT'
  if (response.error === 'error backend') return 'BACKEND_ERROR'
  if (response.error === 'error limit') return 'PAYMENT_LIMIT'

  return response.error
}

/**
 * Создать платеж cardww3 по сумме в долларах
 */
export const createPaymentByDollars = async (dollars) => {
  try {
    const response = await apiService.makeRequest('/api/cardww3/', {
      method: 'POST',
      body: JSON.stringify({ dollar: dollars })
    })

    const normalizedError = normalizeCardWw3CreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating CardWW3 payment by dollars:', error)
    throw error
  }
}

/**
 * Создать платеж cardww3 по количеству кристаллов
 */
export const createPaymentByCrystals = async (crystals) => {
  try {
    const response = await apiService.makeRequest('/api/cardww3/', {
      method: 'POST',
      body: JSON.stringify({ crystal: crystals })
    })

    const normalizedError = normalizeCardWw3CreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (response.link) return { link: response.link }

    throw new Error('Invalid response format: link not found')
  } catch (error) {
    console.error('Error creating CardWW3 payment by crystals:', error)
    throw error
  }
}

/**
 * Открыть ссылку на оплату cardww3 через Telegram WebApp API
 */
export const openCardWw3Payment = (paymentLink, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(paymentLink, onRedirect, 'CardWW3', paymentWindow)
}

export default {
  fetchCardWw3Config,
  fetchCardWw3Packages,
  createPaymentByDollars,
  createPaymentByCrystals,
  openCardWw3Payment
}
